import services from './services'
import segments from './segments'
import home from './home'

const pages = { services, segments, home }

export default pages
